<template>
    <div v-if="competition.dates">
      <b-row>
        <b-col cols=12 md=4 :class="headerClass">Anmeldung:</b-col>
        <b-col cols=12 md=8 :class="contentClass">
          <span v-if="!competition.registrationEnded()">{{ registration }}</span>
          <span v-else>beendet</span>
        </b-col>
      </b-row>

      <b-row v-if="">
        <b-col cols=12 md=4 :class="headerClass">
          <span v-if="!competition.paperDatesAsOnline()">Online-Wettbewerb:</span>
          <span v-else>Wettbewerbszeitraum:</span>
        </b-col>
        <b-col cols=12 md=8 :class="contentClass">{{ online }}</b-col>
      </b-row>

      <b-row v-if="!competition.paperDatesAsOnline()">
        <b-col cols=12 md=4 :class="headerClass">papierbasierter Wettbewerb:</b-col>
        <b-col cols=12 md=8 :class="contentClass">{{ paper }}</b-col>
      </b-row>

      <b-row>
        <b-col cols=12 md=4 :class="headerClass">Übertragung der Daten:</b-col>
        <b-col cols=12 md=8 :class="contentClass">
          <span v-if="!competition.transferEnded()">bis {{ transfer }}</span>
          <span v-else>beendet</span>
        </b-col>
      </b-row>

      <b-row v-if="showPayment">
        <b-col cols=12 md=4 :class="headerClass">Zahlbar:</b-col>
        <b-col cols=12 md=8 :class="contentClass">
          bis {{ payment }}
          <bank-details :school="this.school"></bank-details>
        </b-col>
      </b-row>
    </div>
</template>

<script>
import BankDetails from '@/components/competitions/registration/BankDetails'

const moment = require('moment')

export default {
  name: 'CompetitionDates',
  props: ['competition', 'headerClass', 'contentClass', 'school', 'showPayment'],

  components: {
    BankDetails: BankDetails
  },

  computed: {
    registration: function () {
      let dates = this.competition.getRegistrationDates()
      if (dates) {
        return this.formatDate(dates.start, dates.end)
      }
    },

    online: function () {
      let dates = this.competition.getOnlineDates()
      if (dates) {
        return this.formatDate(dates.start, dates.end)
      }
    },

    paper: function () {
      let dates = this.competition.getPaperDates()
      if (dates) {
        return this.formatDate(dates.start, dates.end)
      }
    },

    transfer: function () {
      let end = this.competition.getTransferEnd()
      if (end) {
        return this.formatDate(end)
      }
    },

    payment: function () {
      let date = this.competition.getPaymentDate()
      if (date) {
        return this.formatDate(date)
      }
    }
  },

  methods: {
    formatDate: (start, end) => {
      start = moment(start)

      let now = moment()
      let format = 'D. MMMM'
      if (now.year() !== start.year()) {
        format += ' YYYY'
      }

      if (!end) {
        return start.format(format)
      }

      end = moment(end)

      return start.format('D. MMMM') + ' - ' + end.format(format)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/DatesTable.vue